import * as E from 'fp-ts/lib/Either'
import { flow } from 'fp-ts/lib/function'
import { IMEI, Marker } from '@/components/Map/types'
import { Route } from 'vue-router'

const findMarker = (markers: Marker[]) => (imei: IMEI): E.Either<string, Marker> => {
  return E.fromNullable('Could not find corresponding marker.')(markers?.find((m: Marker) => String(m.imei) === String(imei)))
}

const findIMEI = (to: Route): E.Either<string, IMEI> => E.fromNullable('Could not find IMEI parameter.')(Number(to.params?.imei))

const isUnloadedIMEI = (selectedIMEI: IMEI) => (imei: IMEI): E.Either<string, IMEI> => E.fromPredicate(
  (imei: IMEI) => imei !== selectedIMEI,
  (imei: IMEI) => 'Prevented redundant routing.'
)(imei)

export const maybeSetMarkerFn = (pred: any, route: Route, selectedIMEI: IMEI, markers: Marker[], success: any, error: any): E.Either<any, any> => {
  return flow(
    pred,
    E.chain(findIMEI),
    E.chain(isUnloadedIMEI(selectedIMEI)),
    E.chain(findMarker(markers)),
    E.map(success),
    E.mapLeft(error)
  )(route)
}
